<div class="filter-modal__body">
    <div class="filter-field">
        <label class="filter-field__label">Select Dealer Business Name</label>
        <app-autocomplete
            [config]="dealerConfig"
            [(selectedOptions)]="selectedDealer"
            valueWith="clientInformationId"
            [options]="dealerOptions()"
            (onSelect)="onDealerSelect($event)"
            (onSearch)="onSearch($event)"
            (onFocus)="onFocus('dealer')"
            [loading]="isLoadingDealers()"
            size="md" />
    </div>

    @if (hostOptionsAvailable()) {
        <div class="filter-field">
            <label class="filter-field__label">Select Host Name</label>
            <app-autocomplete
                [config]="hostConfig"
                [options]="$any(hostOptions())"
                [(selectedOptions)]="selectedHost"
                (onSelect)="onHostSelect($event)"
                (onSearch)="onSearch($event)"
                (onFocus)="onFocus('host')"
                [loading]="isLoadingDealerHosts()"
                size="md" />
        </div>
    } @else {
        <div class="filter-info-box">
            @if (isLoadingDealerHosts()) {
                <p>Loading hosts...</p>
            } @else {
                <p>Host field will appear if Dealer has available hosts</p>
            }
        </div>
    }

    @if (advertiserOptionsAvailable()) {
        <div class="filter-field">
            <label class="filter-field__label">Select Advertiser Name</label>
            <app-autocomplete
                [config]="advertiserConfig"
                [options]="$any(advertiserOptions())"
                [(selectedOptions)]="selectedAdvertiser"
                (onSelect)="onAdvertiserSelect($event)"
                (onSearch)="onSearch($event)"
                (onFocus)="onFocus('advertiser')"
                [loading]="isLoadingDealerAdvertisers()"
                size="md" />
        </div>
    } @else {
        <div class="filter-info-box">
            @if (isLoadingDealerAdvertisers()) {
                <p>Loading advertisers...</p>
            } @else {
                <p>Advertiser field will appear if Dealer has available advertisers</p>
            }
        </div>
    }
</div>
